export const STEP_ID = 'stepId';
export const STEP_DIRECTION = 'stepDirection';
export const LOADING = 'loading';
export const LOADED = 'loaded';
export const PAGE_TITLE = 'page_title';
export const NET_SPEED = 'net_speed';
